import { render, staticRenderFns } from "./ContainerWorkoutLogHistorySkeleton.vue?vue&type=template&id=acbb10c6&scoped=true"
import script from "./ContainerWorkoutLogHistorySkeleton.vue?vue&type=script&lang=js"
export * from "./ContainerWorkoutLogHistorySkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbb10c6",
  null
  
)

export default component.exports